import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { DepositPage } from "@/features/onboarding/pages/deposit-page";

export const Route = createFileRoute("/onboarding/_guarded/deposit")({
	head: () => pageTitle("Deposit"),
	component: DepositPage,
});
